module.exports = __webpack_public_path__ + "static/media/veBackground.94621e58.jpg";